import { DOCUMENT, DatePipe } from "@angular/common";
import { Component, Inject, OnInit, Renderer2 } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import * as SecureLS from "secure-ls";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Math from "exact-math";
import { StorageService } from "../../services/storage.service";
import * as moment from "moment";

const dateRangeValidator: ValidatorFn = (
  control: FormGroup
): ValidationErrors | null => {
  const startDate = control.get("startDate")?.value;
  const endDate = control.get("endDate")?.value;

  if (!startDate || !endDate) {
    return { required: true };
  }

  const start = new Date(startDate);
  const end = new Date(endDate);

  if (end < start) {
    return { invalidRange: true };
  }

  return null;
};

@Component({
  selector: "app-session-master",
  templateUrl: "./session-master.component.html",
  styleUrls: ["./session-master.component.css"],
})
export class SessionMasterComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  roleID = this.storageService.getRole();
  userID = this.ls.get("createdBy");
  alphaPattern = "[a-zA-Z .,]*";
  sessionMasterForm: FormGroup;
  showLoadMore = false;
  page: number = 1;
  page_size: number = 10;
  submitted = false;
  manualUpdate = true;
  swal: any;
  total_count = 0;
  crcreate: any;
  sessionMasterList: any[];
  getclassroom: any;
  editingSession: any;
  is_active = false;
  deleteSession: any;
  editstatus = false;
  crupdate: any;
  crstatusupdate: any;
  editid: any;
  department: any;
  editbut: boolean;
  sessionName: any;
  classno: any;
  depid: any;
  isactiveswitch: any;
  page_count = [];
  pageshow = true;
  htmlpageshow: boolean;
  file_server_id: any;
  total: number;
  p: number;
  pagedItems: any[];
  searchForm: FormGroup;
  filtervalues: boolean;
  chiparray: any = [];
  entryFields: boolean = false;
  createNew: boolean = true;
  filterPopup: any;
  filter_from: any;
  filterPopupfrom: any;
  filter_end: any;
  filterPopupend: any;
  filter_date: string;
  filterPopupdate: string;
  sessionNameList: any;
  backendValidationErrors: null;

  constructor(
    private storageService: StorageService,
    private modalService: NgbModal,
    public router: Router,
    private fb: FormBuilder,
    public globalService: GlobalService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  async ngOnInit() {
    this.searchForm = this.fb.group(
      {
        id: [""],
        startDate: [""],
        endDate: [""],
        sessionName: [""],
      },
      { validator: dateRangeValidator }
    );

    this.sessionMasterForm = this.fb.group(
      {
        id: [""],
        sessionName: [
          "",
          [Validators.required],
        ],
        startDate: ["", [Validators.required]],
        endDate: ["", [Validators.required]],
        is_active: [""],
      },
      { validator: dateRangeValidator }
    );
    this.page = 1;
    this.sessionMasterForm.valueChanges.subscribe((data)=>{
      this.backendValidationErrors = null;
    });
    await this.getSessionMaster();
    await this.getPage(this.page, true);
  }

  openField() {
    this.entryFields = true;
    this.createNew = false;
    this.submitted = false;
  }
  openEdit() {
    this.entryFields = true;
    this.createNew = false;
    this.editbut = false;
    this.sessionMasterForm.reset();
    this.submitted = false;
  }

  cancelFields() {
    this.renderer.removeClass(document.body, "modal-open");
    this.entryFields = false;
    this.createNew = true;
  }

  async getPage(page: number, disableCall: boolean) {
    this.page = page;
    if(!disableCall){
    await this.getSessionMaster();
    }
    const res = await this.serverCall(this.sessionMasterList, page);
    this.total = this.total_count;
    this.p = page;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }
  get forms() {
    return this.sessionMasterForm.controls;
  }
  get forms1() {
    return this.searchForm.controls;
  }
  async createSessionMaster(form: FormGroup) {
    this.submitted = true;
    if (this.sessionMasterForm.valid) {
      this.spinner.show();
      const requestPayload = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        session: form.value.sessionName.trim(),
        start_date: this.filter_from,
        end_date: this.filter_end,
        is_active: "1",
        role_id: this.storageService.getRole(),
      };
      this.crcreate = await this.globalService.create(
        "session/create",
        requestPayload
      );

      if (this.crcreate["status"] === 200) {
        Swal.fire("Success!", this.crcreate["message"], "success");
        this.res();       
        this.backendValidationErrors = null;
        this.cancelFields();       
      } else if (this.crcreate["status"] === 422) {
        this.backendValidationErrors = this.crcreate?.error["content"];
      } else {        
        this.cancelFields();
        this.backendValidationErrors = null;
      }
    }
    this.spinner.hide();
  }

  switch(e) {
    this.isactiveswitch = e;
  }

  getSelectedStartDate(selectedStartDate) {
    if (selectedStartDate) {
      this.filter_from = moment(selectedStartDate).format("YYYY-MM-DD");
    }
  }

  getSelectedEndDate(selectedEndDate) {
    if (selectedEndDate) {
      this.filter_end = moment(selectedEndDate).format("YYYY-MM-DD");
      if (
        new Date(this.filter_end).getTime() <
        new Date(this.filter_from).getTime()
      ) {
        Swal.fire({
          text: "Please select correct dates",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#808080",
        });
      }
    }
  }

  getFilterPopupStartDate(selectedStartDate) {
    if (selectedStartDate) {
      this.filterPopupfrom = moment(selectedStartDate).format("YYYY-MM-DD");
    }
  }

  getFilterPopupEndDate(selectedEndDate) {
    if (selectedEndDate) {
      this.filterPopupend = moment(selectedEndDate).format("YYYY-MM-DD");
      if (
        new Date(this.filterPopupend).getTime() <
        new Date(this.filterPopupfrom).getTime()
      ) {
        Swal.fire({
          text: "Please select correct dates",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#808080",
        });
      }
    }
  }

  getSessionMaster(start_date?, end_date?) {
    this.spinner.show();
    if (this.page === 1) {
      this.sessionMasterList = [];
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      page: this.page,
      role_id: this.storageService.getRole(),
      session: this.sessionName ? this.sessionName : "",
      start_date: start_date
        ? start_date
        : this.filter_from
        ? this.filter_from
        : "",
      end_date: end_date ? end_date : this.filter_end ? this.filter_end : "",
      page_size: this.page_size,
    };
    const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));
    if (!dateKeyExists && filter.start_date && filter.end_date) {
      this.chiparray.push("Date :" + " " + filter.start_date + " - " + filter.end_date);
    }
    this.globalService.get("session/list", filter).then((data) => {
      this.getclassroom = data;
      this.spinner.hide();
      this.total_count = this.getclassroom["content"].count;
      if (this.getclassroom["content"]["rows"].length < this.page_size) {
        this.showLoadMore = true;
      }
      if (this.getclassroom["status"] === 200) {
        this.sessionMasterList = this.getclassroom["content"]["rows"];
        if (this.pageshow === true) {
          this.page_count = [];
          let page_count = Math.ceil(this.total_count);
          if (page_count > 1) {
            this.htmlpageshow = true;
          } else {
            this.htmlpageshow = false;
          }
        }
      } else {
        this.showLoadMore = true;
      }
    });
  }

  editSessionMaster(sessionMaster) {
    Swal.fire({
      title: "Edit ?",
      text: "Are you sure you want to edit this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        this.spinner.show();
        this.editbut = true;
        this.openField();
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          role_id: this.storageService.getRole(),
          id: sessionMaster.id,
        };
        this.editingSession = await this.globalService.get(
          "session/get",
          filter
        );
        let editingSession = this.editingSession["content"];
        if (this.editingSession["status"] === 200) {
          this.sessionMasterForm.controls["id"].setValue(editingSession.id);
          this.sessionMasterForm.controls["sessionName"].setValue(
            editingSession.session
          );
          this.sessionMasterForm.controls["startDate"].setValue(
            new Date(editingSession.start_date)
          );
          this.sessionMasterForm.controls["endDate"].setValue(
            new Date(editingSession.end_date)
          );
          this.filter_from = editingSession.start_date;
          this.filter_end = editingSession.end_date;
          this.editid = editingSession.id;
          this.editstatus = editingSession.is_active;
        }
        this.spinner.hide();
      } else {
        this.cancelFields();
      }
    });
  }

  reset() {
    this.submitted = false;
    // this.sessionMasterForm.reset();
    this.editstatus = false;
    this.isactiveswitch = false;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getSessionMaster();
  }
  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getSessionMaster();
  }
  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getSessionMaster();
  }

  openScrollableContent(longContent) {
    this.document.body.classList.add("date-cls");
    if (this.ls.get("token")) {
      // this.searchForm.controls["date"].setValue(null);
      // this.searchForm.controls["sessionName"].setValue(null);
      this.searchForm.reset();
      const modalRef = this.modalService.open(longContent, {
        scrollable: true,
      });
      modalRef.result.then(
        (data) => {
          this.document.body.classList.remove("date-cls");
        },
        (reason) => {
          this.document.body.classList.remove("date-cls");
        }
      );
    }
  }
  onClose() {
    this.document.body.classList.remove("date-cls");
  }
  Filter(formValue) {
    this.filtervalues = true;
    this.chiparray = [];
    if (this.sessionName != undefined && this.sessionName != "") {
      this.chiparray.push("Session Name :" + " " + this.sessionName);
      this.sessionName = formValue.sessionName.value.trim();
    }    
    
    this.pageshow = true;
    this.page = 1;
    if (formValue.startDate.value && formValue.endDate.value) {
      this.getSessionMaster(this.filterPopupfrom, this.filterPopupend);
    } else {
      this.getSessionMaster();
    }
  }
  res() {
    this.filtervalues = false;
    this.sessionName = null;
    this.classno = null;
    this.filter_from = null;
    this.filter_end = null;
    this.file_server_id = null;
    this.searchForm.reset();
    this.pageshow = true;
    this.page = 1;
    this.getSessionMaster();
  }

  async updateSessionMaster(form: FormGroup) {
    this.submitted = true;
    if (this.sessionMasterForm.invalid) {
      return;
    }
    this.spinner.show();
    const inputData = {
      id: form.value.id ? form.value.id : this.editid,
      vendor_id: this.ls.get("vendor_id"),
      user_id: this.ls.get("createdBy"),
      session: form.value.sessionName.trim(),
      start_date: this.filter_from,
      end_date: this.filter_end,
      role_id: this.storageService.getRole(),
      is_active: "1",
    };
    this.crupdate = await this.globalService.update(
      "session/update",
      inputData
    );
    if (this.crupdate["status"] === 200) {
      Swal.fire("Success!", this.crupdate["message"], "success");
      this.res();
      this.cancelFields();
      this.backendValidationErrors = null;
      this.renderer.removeClass(document.body, 'modal-open')
    } else if (this.crupdate["status"] === 422) {
      this.backendValidationErrors = this.crupdate?.error["content"];
    } else {
      this.cancelFields();
      this.backendValidationErrors = null;
    }
    this.spinner.hide();
  }

  async deleteEditSession(sessionMaster) {
    this.spinner.show();
    Swal.fire({
      title: "Delete ?",
      text: "Are you sure you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#CBCBCB",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed == true) {
        let filter = {
          user_id: this.ls.get("createdBy"),
          vendor_id: this.ls.get("vendor_id"),
          id: sessionMaster.id,
          session: sessionMaster.session,
          role_id: this.storageService.getRole(),
        };
        this.deleteSession = await this.globalService.delete(
          "session/delete",
          filter
        );
        if (this.deleteSession["status"] === 200) {
          this.sessionMasterList = [];
          Swal.fire("Success!", this.deleteSession["message"], "success");
          this.pageshow = true;
          this.getSessionMaster();
        }
      }
    });
    this.spinner.hide();
  }

  formAddReset() {
    this.sessionMasterForm.reset();
    this.editbut = false;
  }
  formUpdateReset() {
    // this.sessionMasterForm.controls["id"].setValue(
    //   this.editingSession["content"].id
    // );
    // this.sessionMasterForm.controls["sessionName"].setValue(
    //   this.editingSession["content"].session
    // );
    // this.filter_from = this.editingSession["content"].start_date;
    // this.filter_end = this.editingSession["content"].end_date;
    // this.editid = this.editingSession["content"].id;
    // this.editstatus = this.editingSession["content"].is_active;
    this.sessionMasterForm.reset();
  }
  paginationCount(value) {
    this.page = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getSessionMaster();
  }
}
